import { useState } from "react";

const ContactUsPage = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert("Thank you for your message! We will get back to you soon.");
    setFormData({ name: "", email: "", message: "" });
  };

  return (
    <div className="max-w-7xl mx-auto px-4 py-8">
      <div className="p-8 bg-white rounded-lg shadow-xl">
        <h2 className="text-3xl font-bold text-gray-800 mb-6">Contact Us</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <div>
            <h3 className="text-xl font-semibold text-gray-700 mb-1">
              Get in Touch
            </h3>
            <p className="text-gray-700 mb-1">
              <strong className="font-medium">Address:</strong>
              <br />
              Nagadevanahalli (Kengeri)
              <br />
              https://maps.app.goo.gl/6ts7LXGjxqc8nyJZ8
              <br />
              <br />
              Bharat nagar (Magadi road)
              <br />
              https://maps.app.goo.gl/uBaTJQhLboxqkSETA
              <br />
              <br />
              Mallathahalli (Ullal)
              <br />
              https://maps.app.goo.gl/kSGKVCvwjokJ7yXq7
            </p>
            <br />
            <p className="text-gray-700 mb-1">
              <strong className="font-medium">Phone:</strong> +1 (555) 123-4567
            </p>
            <br />
            <p className="text-gray-700 mb-1">
              <strong className="font-medium">Email:</strong>{" "}
              info@yogastudioname.com
            </p>
            <br />
            <p className="text-gray-700 mb-2">
              <strong className="font-medium">Hours:</strong> Mon-Fri: 6 AM - 8
              PM, Sat-Sun: 8 AM - 4 PM
            </p>
            <h3 className="text-xl font-semibold text-gray-700 mb-1">
              Send Us a Message
            </h3>
            <form onSubmit={handleSubmit} className="space-y-2">
              <div>
                <label
                  htmlFor="name"
                  className="block text-gray-700 text-sm font-semibold mb-1"
                >
                  Name:
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500"
                  required
                />
              </div>
              <div>
                <label
                  htmlFor="email"
                  className="block text-gray-700 text-sm font-semibold mb-1"
                >
                  Email:
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500"
                  required
                />
              </div>
              <div>
                <label
                  htmlFor="message"
                  className="block text-gray-700 text-sm font-semibold mb-1"
                >
                  Message:
                </label>
                <textarea
                  id="message"
                  name="message"
                  rows="4"
                  value={formData.message}
                  onChange={handleChange}
                  className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500"
                  required
                ></textarea>
              </div>
              <button
                type="submit"
                className="w-full bg-purple-700 text-white py-2 px-4 rounded-md hover:bg-purple-800 transition-colors duration-300 font-semibold text-base shadow-md"
              >
                Send Message
              </button>
            </form>
          </div>
          <div>
            <h3 className="text-xl font-semibold text-gray-700 mb-1">
              Find Us on the Map
            </h3>
            <div className="bg-gray-200 h-64 rounded-lg flex items-center justify-center text-gray-500">
              {/* Placeholder for a map embed */}
              <p>Map Placeholder (e.g., Google Maps embed)</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUsPage;
